<template>
  <div class="col-12">
    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('subjects.addSubjectTitle') }}
            </h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 pb-2 pe-3">
        <div class="row justify-content-center">
          <div class="col-md-12 ms-3">
            <SubjectForm 
              ref="subjectForm"
              :title="$t('subjects.addSubjectTitle')"
              :submit-text="$t('subjects.addSubjectButton')"
              :loading="isSubmitting"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
            
            <div class="d-flex gap-3 mt-3">
              <button 
                type="button" 
                class="btn btn-primary btn-sm flex-grow-1"
                @click="submitForm"
                :disabled="isSubmitting"
              >
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin me-2"></i>
                  {{ $t('subjects.adding') }}
                </span>
                <span v-else>
                  <i class="fas fa-plus ms-2"></i>
                  {{ $t('subjects.add') }}
                </span>
              </button>
              <button 
                type="button" 
                class="btn btn-outline-secondary btn-sm flex-grow-1"
                @click="handleCancel"
                :disabled="isSubmitting"
              >
                <i class="fas fa-times ms-2"></i>
                {{ $t('subjects.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import SubjectForm from '@/components/features/subjects/SubjectForm.vue';
import { useToast } from 'vue-toastification';
import api from '@/api';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const toast = useToast();
const router = useRouter();
const subjectForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  isSubmitting.value = true;
  try {
    await api.post('/subjects', formData);
    toast.success(t('subjects.addSubjectSuccess'));
    router.push('/subjects');
  } catch (error) {
    if (error.response?.status === 422) {
      const errors = error.response.data.errors;
      subjectForm.value?.setErrors(errors);
      for (const field in errors) {
        toast.error(errors[field][0]);
      }
    } else {
      toast.error(error.response?.data?.message || t('subjects.addSubjectError'));
    }
  } finally {
    isSubmitting.value = false;
  }
};

const submitForm = () => {
  subjectForm.value?.submitForm(); 
};

const handleValidationError = () => {
  toast.warning(t('subjects.validationError'));
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/subjects');
  }
};
</script>
